// Copyright © 2025 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { createSelector } from 'reselect'

import { createPaginationIdsSelectorByEntity } from '@ttn-lw/lib/store/selectors/pagination'

const selectMacSettingsProfilesStore = state => state.macSettingsProfiles

export const selectMacSettingsProfilesEntitiesStore = state =>
  selectMacSettingsProfilesStore(state)?.entities
const selectMacSettingsProfilesIds = createPaginationIdsSelectorByEntity('mac_settings_profiles')

export const selectMacSettingsProfiles = createSelector(
  [selectMacSettingsProfilesIds, selectMacSettingsProfilesEntitiesStore],
  (ids, entities) => ids.map(id => entities[id]),
)
export const selectMacSettingsProfilesTotalCount = state =>
  selectMacSettingsProfilesStore(state).totalCount

export const selectMacSettingsProfileById = (state, id) =>
  selectMacSettingsProfilesEntitiesStore(state)[id]
